<panel class="no-padding table-panel">
  <div class="spinner" *ngIf="retrievingInspectionResults">
    <mat-spinner diameter="30"></mat-spinner>
  </div>
  <table class="table table--full-width table--striped table--hover table--sortable"
    *ngIf="!retrievingInspectionResults">
    <!-- <thead>
      <tr>
        <th (click)= "sortBy('Eval')"           style="text-align: center" >{{'Evaluation' | translate | async}}</th>
        <th (click)= "sortBy('InspectionDate')" >{{'Inspection Date' | translate | async}}</th>
        <th (click)= "sortBy('SerialNumber')"   >{{'Serial Number' | translate | async}}</th>
        <th (click)= "sortBy('UnitNumber')"     >{{'Unit Number' | translate | async}}</th> -->
    <!-- <th (click)= "sortBy('AddiUnitNumber')"     >{{'Additional Unit Number' | translate | async}}</th> -->
    <!-- <th (click)= "sortBy('Customer')"       >{{'Customer' | translate | async}}</th>
        <th (click)= "sortBy('Jobsite')"       >{{'Job Site' | translate | async}}</th>
        <th (click)= "sortBy('Model')"         >{{'Model' | translate | async}}</th> -->
    <!-- <th    [attr.disabled] = "true" style="cursor: default;"     width="230px">{{'Status' | translate | async}}</th> -->
    <!-- </tr>
    </thead> -->
    <thead>
      <tr>
        <th (click)="sortBy('Eval')" style="text-align: center" width="100px">
          <span class="header-with-icon">
            {{ 'Evaluation' | translate | async }}
            <i class="material-icons sort-icon" 
              *ngIf="evalOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" 
              *ngIf="!evalOrder.selected">arrow_downward</i>
          </span>
        </th>

        <th (click)="sortBy('InspectionDate')">
          <span class="header-with-icon">
            {{ 'Inspection Date' | translate | async }}
            <i class="material-icons sort-icon" 
              *ngIf="dateOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" 
              *ngIf="!dateOrder.selected">arrow_downward</i>
          </span>
        </th>

        <th (click)="sortBy('SerialNumber')">
          <span class="header-with-icon">
            {{ 'Serial Number' | translate | async }}
            <i class="material-icons sort-icon" 
              *ngIf="serialOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon"
              *ngIf="!serialOrder.selected">arrow_downward</i>
          </span>
        </th>

        <th (click)="sortBy('UnitNumber')">
          <span class="header-with-icon">
            {{ 'Unit Number' | translate | async }}
            <i class="material-icons sort-icon" 
              *ngIf="uitOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" 
              *ngIf="!uitOrder.selected">arrow_downward</i>
          </span>
        </th>

        <th (click)="sortBy('Customer')">
          <span class="header-with-icon">
            {{ 'Customer' | translate | async }}
            <i class="material-icons sort-icon" 
              *ngIf="customerOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" 
              *ngIf="!customerOrder.selected">arrow_downward</i>
          </span>
        </th>

        <th (click)="sortBy('Jobsite')">
          <span class="header-with-icon">
            {{ 'Job Site' | translate | async }}
            <i class="material-icons sort-icon" 
              *ngIf="jobsiteOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" 
              *ngIf="!jobsiteOrder.selected">arrow_downward</i>
          </span>
        </th>

        <th (click)="sortBy('Model')">
          <span class="header-with-icon">
            {{ 'Model' | translate | async }}
            <i class="material-icons sort-icon" 
              *ngIf="modelOrder.selected">arrow_upward</i>
            <i class="material-icons sort-icon" 
              *ngIf="!modelOrder.selected">arrow_downward</i>
          </span>
        </th>
      </tr>
    </thead>

    <tbody>
      <!-- <unsynced-inspection-list-row *ngFor="let i of inspectionResults" [inspectionId]="i"></unsynced-inspection-list-row> -->

      <tr *ngFor="let inspection of inspectionResults">
        <td class="no-padding" (click)="openInspection()" [@fadeIn] style="text-align: center">
          <span class="eval eval--{{inspection.Evaluation | lowercase}}">{{inspection.Evaluation}}</span>
        </td>
        <td (click)="openInspection(inspection)" [@fadeIn]>{{inspection.InspectionDate | date:'dd/MMM/yyyy'}}</td>
        <td (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.SerialNumber">
          {{inspection.SerialNumber }}</td>
        <td (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.UnitNumber">{{inspection.UnitNumber
          }}</td>
        <td (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.CustomerName">
          {{inspection.CustomerName }}</td>
        <td (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.JobsiteName">
          {{inspection.JobsiteName }}</td>
        <td (click)="openInspection(inspection)" [@fadeIn] [attr.title]="inspection.Model">
          {{inspection.Model}}</td>
      </tr>
    </tbody>
  </table>
  <mat-paginator [pageIndex]="pageNumber" [length]="totalResults" [pageSize]="inspectionsPerPage"
    [pageSizeOptions]="[5, 10, 25, 100]" (page)="onPageEvent($event)">
  </mat-paginator>
</panel>